﻿import $ from "jquery";
import ko from "knockout";
import "ElementQueries";

import RootModel from "./RootModel";

ko.setTemplateEngine(new ko.nativeTemplateEngine());

ko.bindingHandlers.productField = {
	init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
		const fieldName = bindingContext.field.name;
		$(element).html(viewModel.info[fieldName]);
	}
};

export default function (model, options) {
	const element = $(`#${options.entryPointId}`);

	if (element.length !== 0) {
		ko.applyBindings(new RootModel(model, options), element[0]);
	}
}
